import { render, staticRenderFns } from "./RestaurantsHeading.vue?vue&type=template&id=7a2eed24&lang=pug&"
import script from "./RestaurantsHeading.vue?vue&type=script&lang=js&"
export * from "./RestaurantsHeading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports